import { useEffect, useState, FC, ReactElement } from 'react';
import styled from 'styled-components';
import { $filterNumberDecimal, $BigNumber, $toFixedFormat } from 'common/utils/met';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useShowVote } from '@/state/base/hooks';
import { useVoteList, useVoteAmount } from '@/state/vote/hooks';
import { useBalance, useDebounce } from '@/hooks';
import { Button } from '@/components';

const Detail: FC = (): ReactElement => {
    const history = useHistory();
    const [debounce] = useDebounce(600);
    const [, getVoteList, loadding] = useVoteList();
    const [, handShowVote] = useShowVote();
    const [, setVoteAmount] = useVoteAmount();
    const [balance, getBalance] = useBalance();
    const [amount, setAmount] = useState<string | number>('');
    const { t } = useTranslation();
    console.log(getVoteList);

    const amountKeyUp = (val, maxValue): string => {
        let _list = val.split('.');
        if ((_list.length === 1 && val) || (_list.length === 2 && Number(_list[1]) > 0)) {
            val = Math.min(Number(val), Number(maxValue));
        }
        return String(val);
    };

    useEffect(() => {
        getBalance('AMAX', 'amax.token');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Dialog>
            <Mask onClick={() => handShowVote(false)}></Mask>
            <Content>
                <Close className="iconfont" onClick={() => handShowVote(false)}>
                    &#xe64f;
                </Close>
                <Title>{t('add-vote.vote')}</Title>
                <Section>
                    <Tip>
                    {t('add-vote.tip')} <span>1 AMAX=10000{t('base.votes')}</span>
                    </Tip>
                    <Div>
                        <Input
                            placeholder="0.0"
                            value={amount}
                            onChange={e => {
                                setAmount($filterNumberDecimal(e.target.value, 4));
                                debounce(() => {
                                    setAmount(amountKeyUp($filterNumberDecimal(e.target.value, 4), $toFixedFormat(balance, 4)));
                                });
                            }}
                        />
                        <Symbol>AMAX</Symbol>
                    </Div>
                    <Balance>
                    {t('add-vote.balance')} {balance} AMAX <span onClick={() => setAmount($toFixedFormat(balance, 4))}>{t('add-vote.all')}</span>
                    </Balance>
                </Section>
                <Footer>
                    <Notice>
                        {t('add-vote.tip2')}
                        <span>
                            {$BigNumber(amount || 0)
                                .multipliedBy(10000)
                                .toFixed(0)}
                        </span>
                        {t('base.votes')}
                    </Notice>
                    <Submit
                        loading={loadding}
                        disabled={!amount || Number(amount) === 0}
                        onClick={async() => {
                            // await getVoteList({}, true, false);
                            setVoteAmount(amount)
                            handShowVote(false);
                            history.push('/rpc-vote');
                        }}
                    >
                        {t('add-vote.submit')}
                    </Submit>
                </Footer>
            </Content>
        </Dialog>
    );
};
export default Detail;

const Dialog = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999;
`;
const Mask = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
`;

const Content = styled.div`
    position: absolute;
    left: 0;
    width: 100%;
    padding: 0.14rem 0.12rem 0.23rem;
    background: #fff;
    background: #ffffff;
    border-radius: 0.08rem 0.08rem 0 0;

    @media screen and (max-width: 449px) {
        bottom: 0;
    }
    @media screen and (min-width: 450px) {
        top: 50%;
        left: 50%;
        width: 500px;
        transform: translate(-50%, -50%);
    }
`;
const Close = styled.i`
    position: absolute;
    right: 0.18rem;
    top: 0.13rem;
    cursor: pointer;
    font-size: 0.13rem;
    color: #cccccc;
`;
const Title = styled.h3`
    height: 0.22rem;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 600;
    font-size: 0.16rem;
    line-height: 0.22rem;
    text-align: center;
    color: #444444;
    margin-bottom: 0.24rem;
`;
const Section = styled.section`
    background: #fafafc;
    border-radius: 0.08rem;
    padding: 0.12rem 0.12rem 0.09rem;
`;
const Tip = styled.div`
    height: 0.2rem;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 0.14rem;
    color: #21212f;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
        font-weight: 400;
        font-size: 0.12rem;
        color: #000000;
        opacity: 0.3;
    }
`;
const Div = styled.div`
    margin: 0.06rem 0 0.1rem;
    height: 0.66rem;
    border-bottom: 0.01rem solid#EEEEEE;
    display: flex;
    align-items: center;
`;
const Input = styled.input`
    flex: 1;
    height: 100%;
    background: none;
    border: none;
    outline: none;
    font-family: 'D-DIN Exp';
    font-style: normal;
    font-weight: 700;
    font-size: 0.2rem;
    color: #3555ff;
    &::placeholder {
        text-indent: 0;
        font-size: 0.2rem;
    }
`;
const Symbol = styled.div`
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 600;
    font-size: 0.16rem;
    color: #000000;
`;
const Balance = styled.p`
    height: 0.17rem;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 0.12rem;
    line-height: 0.17rem;
    color: rgba(33, 33, 47, 0.3);
    span {
        cursor: pointer;
        color: #3555ff;
        margin-left: 0.1rem;
    }
`;
const Footer = styled.footer`
    border-radius: 0.08rem;
    margin-top: 0.37rem;
`;
const Notice = styled.p`
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 0.14rem;
    height: 0.2rem;
    line-height: 0.2rem;
    color: rgba(33, 33, 47, 0.3);
    text-indent: 0.12rem;
    span {
        font-family: 'D-DIN Exp';
        font-style: normal;
        font-weight: 700;
        color: #3555ff;
        margin: 0 0.1rem;
    }
`;
const Submit = styled(Button)`
    width: 100%;
    height: 0.5rem;
    background: #21212f;
    border-radius: 0.12rem;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 600;
    font-size: 0.18rem;
    color: #ffffff;
    margin-top: 0.03rem;
`;
